import script from "./profileView.vue?vue&type=script&setup=true&lang=ts"
export * from "./profileView.vue?vue&type=script&setup=true&lang=ts"

import "./profileView.vue?vue&type=style&index=0&id=765b27dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-765b27dc"]])

export default __exports__